import { auth } from "../firebase/firebaseConfig";
import { API_BASE } from "./config";

async function call(path, options = {}) {
  if (!auth.currentUser) throw new Error("Sign in is required.");
  const token = await auth.currentUser.getIdToken();
  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}`, ...(options.headers || {}) },
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload.error || `Guru Play request failed (${response.status})`);
  return payload;
}

export const listGuruPlays = ({ source, ticker, includeDrafts = false } = {}) => {
  const query = new URLSearchParams();
  if (source) query.set("source", source);
  if (ticker) query.set("ticker", ticker);
  if (includeDrafts) query.set("includeDrafts", "true");
  return call(`/guru-plays?${query}`);
};
export const createGuruPlay = (value) => call("/guru-plays", { method: "POST", body: JSON.stringify(value) });
export const updateGuruPlay = (id, value) => call(`/guru-plays/${id}`, { method: "POST", body: JSON.stringify(value) });
export const deleteGuruPlay = (id) => call(`/guru-plays/${id}`, { method: "DELETE" });
